// extracted by mini-css-extract-plugin
export default {"spin":"button-with-pending_spin__zUwX9","pendingButton":"button-with-pending_pendingButton__gdo4o","isPending":"button-with-pending_isPending__OEZvr"};